<script setup>
import {onMounted, ref} from "vue";
import Grid from "../../../../frontend/src/components/Grid.vue";
import useGrid from "@/composables/useGrid";
import needsService from "@/services/needs.service";

const {items, gridParams, gridMethods} = useGrid(getList);

const columns = [
    {
        label: 'ID',
        name: 'id',
    },
    {
        label: 'Name',
        name: 'name',
        component: 'Link',
    },
    {
        label: 'Short Description',
        name: 'description',
    },
    {
        label: 'Ecosystems',
        name: 'ecosystems',
    },
    {
        label: 'Score',
        name: 'score',
    },
    {
        label: 'Elastic Score',
        name: 'elastic_score',
    },
    {
        label: 'AI rank',
        name: 'ai_rank',
    }
];

const need = ref(null);
const showModal = ref(false);

onMounted(() => {
    gridMethods.setColumns(columns);
});

function getList(params) {
    return needsService.getFoundStartups(need.value.id, params);
}

function open(param) {
    need.value = param;
    gridMethods.resetList();
    showModal.value = true;
}

defineExpose({
    open
});

</script>

<template>
    <b-modal v-if="need" v-model="showModal" title="Found Startups" hide-footer modal-class="modal-w-xxl">
        <div class="mb-2">
            <div>
                <strong>Name:</strong> {{need.name}}
            </div>
            <div class="mt-2">
                <strong>Keywords:</strong> {{need.keywords}}<br>
            </div>
        </div>

        <Grid
            :columns="columns"
            :data="items"
            :page-length="parseInt(gridParams.pageLength)"
            :total-rows-count="gridParams.totalRowsCount"
            :currentPage="gridParams.currentPage"
            class="mb-3"
            @changePage="gridMethods.changePage"
        >
            <template #cell-ecosystems="{ row }">
                <span v-for="(ecosystem, index) in row.ecosystems" :key="ecosystem.id">
                    <a :href="ecosystem.url" target="_blank">{{ecosystem.name}}</a>
                    <span v-if="index < row.ecosystems.length - 1">, </span>
                </span>
            </template>
        </Grid>
    </b-modal>
</template>

<style scoped>

</style>
